import layoutAdminView from './layoutAdminComponent.html';
import './layoutAdminComponent.css';

export function layoutAdminComponent() {
	return {
		transclude: true,
		bindings: {
			contentWidth: '<?',
		},
		controllerAs: 'vm',
		controller: layoutAdminComponentCtrl,
		template: layoutAdminView,
	};
}

class layoutAdminComponentCtrl {
	$onInit = () => {
		this.containerClass = 'container-' + (this.contentWidth || 1280);
		this.filter = '';
	};
}
